import { writable, get } from "svelte/store";

export const msgBox = writable({ show: false, title: "", message: "", onNegative: null, onPositive: null });

export function showMsgBox(title, message, onNegative = () => {}, onPositive = () => {}) {
  msgBox.set({ show: true, title, message, onNegative, onPositive });
}

export function handleNegative() {
  msgBox.update(v => {
    v.show = false;
    v.onNegative?.();
    return v;
  });
}

export function handlePositive() {
  msgBox.update(v => {
    v.show = false;
    v.onPositive?.();
    return v;
  });
}

export function isOkOnly() {
    const v = get(msgBox);
    return v.onPositive == null;
}